import AddToPortfolio from "@components/Forms/AddToPortfolio";

import useRemoveCompanies from "@hooks/useRemoveCompanies";

import { CompanyType } from "@interfaces/company.type";

import { useAddCompaniesToTechnologyQuery, useCreateTechnologyFromCompanyIdsQuery } from "@queries/portfolio.query";

import { PopupActions } from "@store/popupStore";

interface IUseTechnologyCompanySearchToolbar {
  allCompanies: CompanyType[];
  isFilterOpen: boolean;
  selectedIds: string[];
  setIsFilterOpen: (isOpen: boolean) => void;
  technologyId: string;
  technologyName: string;
  workflow: string;
}

const useTechnologyCompanySearchToolbar = ({
  allCompanies,
  isFilterOpen,
  selectedIds,
  setIsFilterOpen,
  technologyId,
  technologyName,
}: IUseTechnologyCompanySearchToolbar) => {
  const { mutateAsync: createTechnologyFromId } = useCreateTechnologyFromCompanyIdsQuery();
  const { mutateAsync: addCompaniesToTechnology } = useAddCompaniesToTechnologyQuery();

  const toggleFilterVisibility = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const companiesToAddOrRemove = allCompanies
    .filter((company) => selectedIds.includes(company.id))
    .map((company) => company.id)
    .map((id) => id);

  const removeCompanies = useRemoveCompanies();

  const handleRemoveCompanies = (companyId?: string) => {
    if (!technologyId) return;
    void removeCompanies({
      companyIds: companyId ? [companyId] : companiesToAddOrRemove,
      name: technologyName,
      technologyId,
    });
  };

  const handleAddCompaniesToTechnology = () => {
    PopupActions.openModal({
      content: (
        <AddToPortfolio
          addToTechnology={async (technologyId, technologyName) => {
            await addCompaniesToTechnology({
              companyIds: companiesToAddOrRemove,
              technologyId,
              technologyName,
            });
            PopupActions.closeModal();
          }}
          createTechnology={async (name) => {
            await createTechnologyFromId({
              companyIds: companiesToAddOrRemove,
              description: "",
              name,
            });
            PopupActions.closeModal();
          }}
        />
      ),
      title: "Save to Technology",
    });
  };

  return {
    handleAddCompaniesToTechnology,
    handleRemoveCompanies,
    toggleFilterVisibility,
  };
};

export default useTechnologyCompanySearchToolbar;
